import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Text, Box } from 'grommet'
import { navigate, Link } from 'gatsby'
import { upperFirst, get, isEqual, find, map, some, isNil } from 'lodash/fp'
import numberWithCommas from '../lib/numberWithCommas'

import Loading from './Loading'
import Button from './Button'
import OrderReview from './OrderReview'
import ButtonCheckout from './ButtonCheckout'
import ConstrainedContainer from './ConstrainedContainer'
import { ChevronUp } from './Icons'

class FormConfirm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      processingPayment: false,
      paymentStatus: 'initial',
      paymentError: null,
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.onComplete = this.onComplete.bind(this)
  }

  onSubmit() {
    this.setState({ processingPayment: true })
  }

  onComplete(data) {
    if (data.error) {
      this.setState({
        processingPayment: false,
        paymentStatus: 'error',
        paymentError: data.error,
      })
    } else {
      this.setState({ processingPayment: false })
      navigate(`/thanks`)
    }
  }

  componentDidMount() {
    const {
      product,
      skuId,
      metadata: { productSku, quantity, list, mailType },
    } = this.props
    if (isNil(skuId)) {
      return navigate(`/${product.toLowerCase()}/list`)
    }
    if (isNil(productSku)) {
      return navigate(`/${product.toLowerCase()}`)
    }
    if (some(true, map(isNil, [quantity, list, mailType, skuId]))) {
      navigate(`/${product.toLowerCase()}/list`)
    }
  }

  render() {
    const {
      data,
      product,
      quantity,
      productInfo,
      metadata,
      amount,
      noList,
    } = this.props
    const { processingPayment, paymentStatus, paymentError } = this.state
    const orderDescription = `${numberWithCommas(quantity)} ${get(
      'attributes.name',
      productInfo
    )} ${get('attributes.mailType', productInfo)} ${upperFirst(product)}`
    return (
      <Box fill>
        {processingPayment && <Loading overlay text="Processing order..." />}

        {paymentStatus === 'initial' && (
          <Box flex="grow">
            <ConstrainedContainer inner>
              <OrderReview product={product} data={data} />
            </ConstrainedContainer>
            <Box
              align="stretch"
              direction="row"
              alignContent="between"
              justify="between"
            >
              <Link to={`/${product}/list`}>
                <Button
                  label="Previous"
                  icon={<ChevronUp size="small" color="dark-1" />}
                />
              </Link>
              <ButtonCheckout
                description={orderDescription}
                amount={amount}
                metadata={metadata}
                onSubmit={this.onSubmit}
                onComplete={this.onComplete}
                shippingAddress={noList}
              />
            </Box>
          </Box>
        )}
        {paymentStatus === 'error' && (
          <Box>
            <Text>Error! {paymentError}</Text>
          </Box>
        )}
      </Box>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const sku = find(
    x => isEqual(state.order.productSku, get('id', x)),
    ownProps.data
  )
  const quantity = state.order.quantity
  const productInfo = state.order.productInfo
  const amount = get('price', sku) * quantity
  return {
    metadata: {
      productSku: state.order.productSku,
      artFront: state.order.art.none ? 'Need Art' : state.order.art.front,
      artBack: state.order.art.none ? 'Need Art' : state.order.art.back,
      artEnvelope: state.order.art.noEnvelope
        ? 'No Envelope Art'
        : state.order.art.envelope,
      list: state.order.noList ? 'Need List' : state.order.list,
      quantity: state.order.quantity,
      mailType: state.order.mailType,
      npa: state.order.npa,
    },
    noList: state.order.noList,
    skuId: state.order.productInfo.id,
    productInfo,
    quantity,
    amount,
  }
}

FormConfirm.propTypes = {
  data: PropTypes.array,
  product: PropTypes.string,
  initialValues: PropTypes.object,
  art: PropTypes.object,
  list: PropTypes.string,
  quantity: PropTypes.number,
  mailType: PropTypes.string,
  productInfo: PropTypes.object,
  metadata: PropTypes.object,
  amount: PropTypes.number,
  noList: PropTypes.bool,
  skuId: PropTypes.string,
}

export default connect(mapStateToProps)(FormConfirm)
